<template>
  <div>
    <header-navigation></header-navigation>
    <!-- <template v-for="(block, index) in content">
      <component
        :is="block.acf_fc_layout"
        v-bind:acf="block[block.acf_fc_layout]"
        v-bind:data="block[block.acf_fc_layout]"
        :key="index"
      ></component>
    </template> -->
    <component-c225c07b
      v-bind:resmedCorporateAcf="content"
    ></component-c225c07b>
    <div v-if="animation">
      <section
        class="for-professionals"
        resmed-component-name="for-professionals"
      >
        <for-professionals v-bind="animation"> </for-professionals>
      </section>
    </div>
    <div v-if="glossary">
      <component-f7d0bf1d v-bind:acf="glossary"></component-f7d0bf1d>
    </div>
    <footer>
      <nav class="company-pages px-3 px-md-0">
        <div class="container">
          <div class="">
            <footer-navigation
              v-bind:category="'quick-links'"
            ></footer-navigation>
          </div>
          <hr class="d-none d-md-block" />

          <div class="row">
            <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
              <footer-navigation
                v-bind:category="'useful-links'"
              ></footer-navigation>
            </div>

            <div class="col-lg-4">
              <social-media></social-media>
              <div class="copyright-disclaimers d-none d-md-block">
                <p><span>© ResMed</span> {{ $getTranslation("All rights reserved.", $route.params.region) }}</p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </footer>
    <modal-video></modal-video>
  </div>
</template>

<script>
// import jsonData from "./assets/data.json";
// import group from "./components/navigation/group.vue";
import headerNavigation from "./components/navigation/header.vue";
import footerNavigation from "./components/navigation/footer.vue";
import socialMedia from "./components/navigation/social-media.vue";

export default {
  components: { headerNavigation, footerNavigation, socialMedia },
  data() {
    return {
      content: {},
      animation: {},
      glossary: {},
    };
  },
  name: "Search",
  created() {},
  computed: {
    myFields: () => JSON.parse(JSON.stringify(this.content.fields)),
  },
};
</script>

<style>
.for-professionals {
  padding: 7rem 0 1rem 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
